import React from 'react'
import Button from './Button'
import setClass from 'classnames'

const Modal = props => {
  const className = setClass({
    'modal': true,
    'is-active': props.isActive
  })
  return (
    <div className={className}>
      <div className="modal-background" onClick={props.onClose} />
      <div className="modal-card">
        <ModalHeader title={props.title} onClose={props.onClose} />
        <ModalBody content={props.children} />
        <ModalFooter options={props.options} onClose={props.onClose} />
      </div>
    </div> 
  )
}

const ModalHeader = props => {
  return (
    <header className='modal-card-head'>
      <p className="modal-card-title">{props.title}</p>
      <button className="delete" onClick={props.onClose} aria-label="close"></button>
    </header>
  )
}

const ModalBody = props => {
  return (
    <section className="modal-card-body">
      {props.content}
    </section>
  )
}

const ModalFooter = props => {
  const { options } = props
  options.push({
    text: 'Fechar',
    type: 'button',
    onClick: props.onClose
  })
  return (
    <footer className="modal-card-foot has-text-right">
      {options.map(option => {
        return <Button key={option.text} fieldData={option} />
      })}
    </footer>
  )
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/generic/Modal.js